window.config = {
  webPath: 'cmbi/web',

  itradeAPI: location.origin,
  itradePath: 'ttllite',

  MDSStreamingAPI: 'ws://ttl2aacloud01.tx-tech.com/streaming',
  MDSSnapshotAPI: 'ws://ttl2aacloud01.tx-tech.com/snapshot',
  MDSOthersAPI: 'ws://ttl2aacloud01.tx-tech.com/info',
  MDSPath: 'pubsub',

  MDSEntityKey: 'SCB',
  MDSSuperkey: 'shcb2txtech01keyencrypt20key0315',

  winvestorAPI: location.origin,
  winvestorPath: 'ttl/api',

  winvestorDeviceID: 'itrade7.5-web-cmbi',
  winvestorConsumerId: 'winvestor_cmbi_broker',
  winvestorConsumerSecret: '',

  exportExeclFile: 'true',

  // en_US 英 zh_CN 简 zh_TW 繁
  defaultLanguage: 'zh_CN', 

}